import { FileUploadProgressDTO } from "@js/DTO/FileUploadProgressDTO.cs.d";
import { RoleService } from "@js/services/RoleService";
import {
  AreaUnitEnum,
  Case,
  CaseClient,
  CaseCrudClient,
  ClassUseEnum,
  DevelopmentInput,
  DevelopmentInputClient,
  DevelopmentInputSchedule,
  DevelopmentInputScheduleClient,
  FileAttachment,
  FileAttachmentClient,
  FileAttachmentCrudClient,
  ModuleEnum,
  PreAgreementEnum,
  ScheduleTypeEnum,
  TenureEnum,
  UnitTypeEnum,
  UserClient,
} from "@src/apis/ModularClient";
import { FileAttachmentHelper } from "@js/helpers/FileAttachmentHelper";
import { Expand } from "@ccq/ts-lib";
import { ODataHelper } from "@js/helpers/ODataHelper";

export class DevelopmentInputScheduleController {
  isLoggedInUser: boolean = false;
  dataLoading: boolean = false;

  saving: boolean = false;
  saved: boolean = false;
  error: boolean = false;
  selectedSection: string;
  developmentInput: DevelopmentInput;
  developmentInputid: number;
  objects: DevelopmentInputSchedule[]; // This is a full list of houses, flats, commercial units and parking spaces in the dev schedule
  objectsMarkedForDeletion: DevelopmentInputSchedule[];
  houses: DevelopmentInputSchedule[];
  flats: DevelopmentInputSchedule[];
  communalAreas: DevelopmentInputSchedule[];
  commercialUnits: DevelopmentInputSchedule[];
  parkingSpaces: DevelopmentInputSchedule[];
  selectedObject: DevelopmentInputSchedule;
  OverallGDVLocal: number;
  OverallSQft: number = 0;
  sqlUnmatch: boolean = false;
  fetchingObjects: boolean;
  fetchingObject: boolean;

  fileUpload: Expand<FileAttachment>[];
  uploadingFiles: FileUploadProgressDTO[];
  case: Expand<Case, { readonly attachments: true; readonly developmentInput: true }>;
  file: FileAttachment;
  caseTitle: string;
  thisModuleSection: ModuleEnum = ModuleEnum.DevelopmentSchedule;
  openModal: boolean = false;
  seeFiles: boolean = false;
  seeInfo: boolean = false;

  showInformationMessage: boolean = false;
  messageContent: string;
  savingInProgress: boolean = false;
  showAutofill: boolean = false;

  GDVmismatch: boolean = false;
  OverallFlats: number = 0;
  OverallHouses: number = 0;
  OverallCommercial: number = 0;
  OverallCommunal: number = 0;

  parkingSoldSeparately: boolean;

  currentCaseNumber: number;

  developmentScheduleForm: ng.IFormController;

  //addingSubobject: boolean;

  //subobjects: SubobjectDTO[];
  //selectedSubobject: SubobjectDTO;

  //fetchingSubobjects: boolean;
  //fetchingSubobject: boolean;

  DevelopmentInputscheduleForm: ng.IFormController;
  DevelopmentScheduleFormUnitsDetailForm: ng.IFormController;
  //subDevelopmentInputscheduleForm: ng.IFormController;

  previousHouseNumber: number = 0;
  previousFlatNumber: number = 0;
  previousCommunalNumber: number = 0;
  previousParkingNumber: number = 0;
  previousCommercialNumber: number = 0;

  static $inject = [
    "$routeParams",
    "$rootScope",
    "DevelopmentInputScheduleClient",
    "DevelopmentInputClient",
    "$location",
    "$q",
    "CaseClient",
    "FileAttachmentHelper",
    "FileAttachmentClient",
    "RoleService",
    "$window",
    "$cookies",
    "UserClient",
    "CaseCrudClient",
    "ODataHelper",
    "FileAttachmentCrudClient",
  ];
  //private $subobjectservice: App.Services.SubobjectService
  constructor(
    private $routeParams: ng.route.IRouteParamsService,
    private $rootScope: ng.IRootScopeService,
    private developmentInputScheduleClient: DevelopmentInputScheduleClient,
    private developmentInputClient: DevelopmentInputClient,
    private $location: ng.ILocationService,
    protected $q: ng.IQService,
    private caseClient: CaseClient,
    private fileAttachmentHelper: FileAttachmentHelper,
    private fileAttachmentClient: FileAttachmentClient,
    private roleService: RoleService,
    private $window: ng.IWindowService,
    private $cookies: ng.cookies.ICookiesService,
    private userService: UserClient,
    private caseCrudClient: CaseCrudClient,
    private odataHelper: ODataHelper,
    private fileAttachmentCrudClient: FileAttachmentCrudClient,
  ) {
    if ($cookies.get("access_token")) {
      this.isLoggedInUser = true;

      this.userService.getCurrentUserAutofill().then((response) => {
        this.showAutofill = response;
      });
    }

    this.objects = [{} as DevelopmentInputSchedule];

    if (this.$routeParams.CaseId) {
      this.currentCaseNumber = this.$routeParams.CaseId;
    }

    this.odataHelper
      .getOne(this.caseCrudClient, {
        filter: {
          id: {
            eq: Number(this.$routeParams.CaseId),
          },
        },
        expand: {
          developmentInput: true,
        },
      })
      .then((response) => {
        this.odataHelper
          .getMany(this.fileAttachmentCrudClient, {
            filter: {
              caseId: {
                eq: Number(this.$routeParams.CaseId),
              },
            },
          })
          .then((attachments) => {
            if (response == null) {
              if (this.isLoggedInUser) {
                this.$location.path("/userdashboard");
              }
            } else {
              this.case = response as typeof response & { attachments: any[] };
              this.case.attachments = attachments;
              this.fileUpload = attachments;
              this.caseTitle = response.developmentInput.searchName;
              this.calculateFilesForThisModule();
            }
          });
      });

    if (this.$routeParams.DevelopmentId && this.$routeParams.DevelopmentId != "null") {
      this.developmentInputid = this.$routeParams.DevelopmentId;
      this.developmentInputClient.fetch(this.developmentInputid).then((response) => {
        if (response == null) {
          if (this.isLoggedInUser) {
            this.$location.path("/userdashboard");
          }
        } else {
          this.developmentInput = response;

          this.updateObjects();

          if (this.developmentInput) {
            this.CalcAll();
          }
        }
      });
    }
  }
  formChanged(): void {
    (this.$rootScope as any).formSaved = false;
  }
  //ReduceOrInceaseRecordsOfType(rectype:ScheduleTypeEnum) {

  //}

  //SingleUnitChanged() {
  //    this.developmentInput.howManyUnits = 1;
  //    this.developmentInput.howManyHouses = 0;
  //    this.developmentInput.howManyParkingSpaces = 0;
  //    this.developmentInput.howManyFlats = 0;

  //}
  setAllFormsPristine(): void {
    if (this.developmentScheduleForm) {
      this.developmentScheduleForm.$setPristine();
    }
    if (this.DevelopmentScheduleFormUnitsDetailForm) {
      this.DevelopmentScheduleFormUnitsDetailForm.$setPristine();
    }
  }

  NumberCommercialChanged() {
    if (this.developmentInput.howManyUnits == undefined) {
      this.developmentInput.howManyUnits = 0;
    }

    (this.developmentInput.howManyUnits || this.developmentInput.howManyUnits == 0) &&
      this.NumberChanged(ScheduleTypeEnum.Commercial, this.developmentInput.howManyUnits);

    this.commercialUnits.length = this.developmentInput.howManyUnits;

    this.CalcGDVCorporateUnitsSpaces();
    this.previousCommercialNumber = this.developmentInput.howManyUnits;
  }

  NumberHousesChanged() {
    if (this.developmentInput.howManyHouses == undefined) {
      this.developmentInput.howManyHouses = 0;
    }

    (this.developmentInput.howManyHouses || this.developmentInput.howManyHouses == 0) &&
      this.NumberChanged(ScheduleTypeEnum.House, this.developmentInput.howManyHouses);

    this.houses.length = this.developmentInput.howManyHouses;

    this.CalcGDVHouses();
    this.previousHouseNumber = this.developmentInput.howManyHouses;
  }

  NumberFlatsChanged() {
    if (this.developmentInput.howManyFlats == undefined) {
      this.developmentInput.howManyFlats = 0;
    }

    (this.developmentInput.howManyFlats || this.developmentInput.howManyFlats == 0) &&
      this.NumberChanged(ScheduleTypeEnum.Flat, this.developmentInput.howManyFlats);

    this.flats.length = this.developmentInput.howManyFlats;
    this.CalcGDVFlats();

    this.previousFlatNumber = this.developmentInput.howManyFlats;
  }

  NumberCommunalAreas() {
    if (this.developmentInput.howManyCommunalAreas === undefined) {
      this.developmentInput.howManyCommunalAreas = 0;
    }

    (this.developmentInput.howManyCommunalAreas || this.developmentInput.howManyCommunalAreas == 0) &&
      this.NumberChanged(ScheduleTypeEnum.Communal, this.developmentInput.howManyCommunalAreas);

    this.communalAreas.length = this.developmentInput.howManyCommunalAreas;
  }

  SetParkingSpacesToZero() {
    if (this.developmentInput.parkingSoldSeparately === true) {
      this.NumberChanged(ScheduleTypeEnum.Parking, 0);
      this.CalcGDVParkingSpaces();
    }
  }

  NumberParkingSpacesChanged() {
    if (this.developmentInput.howManyParkingSpaces == undefined) {
      this.developmentInput.howManyParkingSpaces = 0;
    }

    (this.developmentInput.howManyParkingSpaces || this.developmentInput.howManyParkingSpaces == 0) &&
      this.NumberChanged(ScheduleTypeEnum.Parking, this.developmentInput.howManyParkingSpaces);

    this.parkingSpaces.length = this.developmentInput.howManyParkingSpaces;

    this.CalcGDVParkingSpaces();

    this.previousParkingNumber = this.developmentInput.howManyParkingSpaces;
  }
  CalcTotalForListOfSalesPrices(salesprices: DevelopmentInputSchedule[]): number {
    var total: number = 0;
    salesprices.forEach((x) => {
      if (x.salesPrice && x.salesPrice > 0) {
        total = total + Number(x.salesPrice);
      }
    });
    return total;
  }
  CalcTotalForListOfSalesPricesMultQuanity(salesprices: DevelopmentInputSchedule[]): number {
    var total: number = 0;
    salesprices.forEach((x) => {
      if (x.salesPrice && x.salesPrice > 0 && x.numberOfUnits && x.numberOfUnits > 0) {
        total = total + Number(x.salesPrice) * x.numberOfUnits;
      }
    });
    return total;
  }
  CalcGDVHouses() {
    this.developmentInput.houses_GDV = this.CalcTotalForListOfSalesPrices(this.houses);
    this.CalcOverallTotal();
  }
  CalcGDVFlats() {
    this.developmentInput.flats_GDV = this.CalcTotalForListOfSalesPrices(this.flats);
    this.CalcOverallTotal();
  }
  CalcGDVParkingSpaces() {
    this.developmentInput.parking_GDV = this.CalcTotalForListOfSalesPricesMultQuanity(this.parkingSpaces);
    this.CalcOverallTotal();
  }
  CalcGDVCorporateUnitsSpaces() {
    this.developmentInput.commercial_GDV = this.CalcTotalForListOfSalesPrices(this.commercialUnits);
    this.CalcOverallTotal();
  }
  CalcOverallTotal() {
    this.OverallGDVLocal = 0;

    if (this.developmentInput.cI_EndPropType == 1 || this.developmentInput.cI_EndPropType == 2) {
      this.OverallGDVLocal +=
        this.developmentInput.houses_GDV + this.developmentInput.flats_GDV + this.developmentInput.parking_GDV;
    }

    if (this.developmentInput.cI_EndPropType != 1) {
      this.OverallGDVLocal += this.developmentInput.commercial_GDV;
    }

    if (this.OverallGDVLocal > 0 && this.OverallGDVLocal !== this.developmentInput.cI_GDV) {
      this.GDVmismatch = true;
    } else {
      this.GDVmismatch = false;
    }
  }

  CalcOverallSQft() {
    this.OverallSQft = 0;
    this.OverallHouses = 0;
    this.OverallFlats = 0;
    this.OverallCommercial = 0;
    this.OverallCommunal = 0;

    if (this.houses && this.houses.length > 0) {
      var tempHouseArray = this.houses.filter((house) => house.area > 0);

      tempHouseArray.forEach((i) => (i.areaUnit = this.developmentInput.dI_AreaUnit));

      if (tempHouseArray && tempHouseArray.length > 0) {
        this.OverallHouses = tempHouseArray.map((i) => i.area).reduce((a, b) => a + b);
      }
    }

    if (this.flats && this.flats.length > 0) {
      var tempFlatArray = this.flats.filter((flat) => flat.area > 0);

      tempFlatArray.forEach((i) => (i.areaUnit = this.developmentInput.dI_AreaUnit));

      if (tempFlatArray && tempFlatArray.length > 0) {
        this.OverallFlats = tempFlatArray.map((i) => i.area).reduce((a, b) => a + b);
      }
    }

    if (this.commercialUnits && this.commercialUnits.length > 0) {
      var tempCMUArray = this.commercialUnits.filter((commercialUnit) => commercialUnit.area > 0);
      tempCMUArray.forEach((i) => (i.areaUnit = this.developmentInput.dI_AreaUnit));

      if (tempCMUArray && tempCMUArray.length > 0) {
        this.OverallCommercial = tempCMUArray.map((i) => i.area).reduce((a, b) => a + b);
      }
    }

    if (this.communalAreas && this.communalAreas.length > 0) {
      this.communalAreas = this.checkIfAreaisNull(this.communalAreas);
      this.communalAreas = this.checkIfDescriptionIsNull(this.communalAreas);
      var tempCAArray = this.communalAreas.filter((communalArea) => communalArea.area > 0);

      tempCAArray.forEach((i) => (i.areaUnit = this.developmentInput.dI_AreaUnit));

      if (tempCAArray && tempCAArray.length > 0) {
        this.OverallCommunal = tempCAArray.map((i) => i.area).reduce((a, b) => a + b);
      }
    }

    if (this.developmentInput.cI_EndPropType == 1 || this.developmentInput.cI_EndPropType == 2) {
      this.OverallSQft += this.OverallHouses + this.OverallFlats + this.OverallCommunal;
    }

    if (this.developmentInput.cI_EndPropType != 1) {
      this.OverallSQft += this.OverallCommercial;
    }

    if (this.OverallSQft !== this.developmentInput.dI_AreaSalesAreaResidential) {
      this.sqlUnmatch = true;
    } else {
      this.sqlUnmatch = false;
    }
  }

  checkIfAreaisNull(overallBuild: DevelopmentInputSchedule[]) {
    return overallBuild.map((i) => {
      if (i.area === undefined || i.area === null) {
        i.area = 0;
      } else {
        i.area;
      }
      return i;
    });
  }

  checkIfDescriptionIsNull(overallBuild: DevelopmentInputSchedule[]) {
    return overallBuild.map((i) => {
      if (i.description === undefined || i.description === null) {
        i.description = "Communal Areas";
      }
      return i;
    });
  }

  CalcAll() {
    if (this.developmentInput && this.objects && this.objects.length > 0) {
      this.developmentInput.houses_GDV =
        this.houses && this.houses.length > 0 ? this.CalcTotalForListOfSalesPrices(this.houses) : null;
      this.developmentInput.parking_GDV =
        this.parkingSpaces && this.parkingSpaces.length > 0
          ? this.CalcTotalForListOfSalesPricesMultQuanity(this.parkingSpaces)
          : null;
      this.developmentInput.flats_GDV =
        this.flats && this.flats.length > 0 ? this.CalcTotalForListOfSalesPrices(this.flats) : null;
      this.developmentInput.commercial_GDV =
        this.commercialUnits && this.commercialUnits.length > 0
          ? this.CalcTotalForListOfSalesPrices(this.commercialUnits)
          : null;
      this.CalcOverallTotal();
      this.CalcOverallSQft();
    }
  }
  FilterMainObjects(recType: ScheduleTypeEnum): DevelopmentInputSchedule[] {
    if (this.objects) {
      return this.objects
        .filter((x) => x.scheduleType == recType)
        .sort(function (a, b) {
          return a.orderId < b.orderId ? -1 : 1;
        });
    }
    return null;
  }
  NumberChanged(recType: ScheduleTypeEnum, numberCurrently: number) {
    var currentObjects: DevelopmentInputSchedule[];

    // by using = when currentObjects changes the original array will also change as it is "copied" by reference
    switch (recType) {
      case ScheduleTypeEnum.Commercial:
        currentObjects = this.commercialUnits;
        break;
      case ScheduleTypeEnum.Flat:
        currentObjects = this.flats;
        break;
      case ScheduleTypeEnum.House:
        currentObjects = this.houses;
        break;
      case ScheduleTypeEnum.Parking:
        currentObjects = this.parkingSpaces;
        break;
      case ScheduleTypeEnum.Communal:
        currentObjects = this.communalAreas;
        break;
    }

    //get back list related to corporate units
    var difference: number = numberCurrently - currentObjects.length;
    if (difference < 0) {
      difference = Math.abs(difference);
      //remove the latter ones

      for (var i = currentObjects.length - difference; i < currentObjects.length; i++) {
        if (!this.objectsMarkedForDeletion) {
          this.objectsMarkedForDeletion = [];
        }
        this.objectsMarkedForDeletion.push(currentObjects[i]);
      }
    } else if (difference > 0) {
      //add new ones
      for (var i = 0; i < difference; i++) {
        var singlerec: DevelopmentInputSchedule = {} as DevelopmentInputSchedule;
        singlerec.scheduleType = recType;
        singlerec.developmentInputId = this.developmentInput.id;
        singlerec.salesPrice = 0;

        if (recType === 0) {
          singlerec.tenure = TenureEnum.Freehold;
        }
        if (recType === 1) {
          singlerec.tenure = TenureEnum.Leasehold;
        }

        currentObjects.push(singlerec);
      }
    }
  }

  updateObjects() {
    this.fetchingObjects = true;

    // Fetch all objects.
    this.developmentInputScheduleClient
      .fetchByCaseId(this.developmentInputid)
      .then((response) => {
        this.objects = response;

        this.objects.forEach((o) => {
          o.area != 0 ? o.area : (o.area = null);
        });

        this.populatePropertyArrays();

        this.CalcAll();
        this.preSelectedItem();

        this.NumberCommercialChanged();
        this.NumberCommunalAreas();
        this.NumberFlatsChanged();
        this.NumberHousesChanged();
        this.NumberParkingSpacesChanged();
      })
      .finally(() => {
        this.fetchingObjects = false;
      });
  }

  private preSelectedItem() {
    if (this.$routeParams.Id) {
      let selectedObject = this.objects.find((value, index) => {
        return value.id === parseInt(this.$routeParams.objectId);
      });

      this.selectObject(selectedObject);
    }
  }

  selectObject(object: DevelopmentInputSchedule) {
    this.selectedObject = object;

    //this.fetchingSubobjects = true;
    //this.$subobjectservice.fetchSubobjectsForObject(object.Id).then((response) => {
    //    this.subobjects = response;
    //    this.fetchingSubobjects = false;
    //}).catch((response) => {
    //    this.fetchingSubobjects = false;
    //});

    this.selectedSection = "details";
  }

  createObject() {
    this.selectedSection = "details";
    this.selectedObject = {} as DevelopmentInputSchedule;
  }

  save(): ng.IPromise<number[]> {
    this.saving = true;
    let defer = this.$q.defer<number[]>();

    // Concatenate the separate arrays back into the main objects array for saving
    this.objects = this.houses.concat(this.flats, this.commercialUnits, this.parkingSpaces, this.communalAreas);

    this.objects.forEach((o) => {
      o.salesPrice > -1 ? o.salesPrice : (o.salesPrice = 0);
    });

    this.objects.forEach((o) => {
      o.area > 0 ? o.area : (o.area = 0);
    });

    this.setDefaultValuesForDevelopmentInputSchedule();

    this.developmentInputScheduleClient
      .addUpdateListReturnOnlyID(this.objects)
      .then((response) => {
        this.objects.forEach((o) => {
          o.area != 0 ? o.area : (o.area = null);
        });
        //set ids to those of response
        this.objects.forEach((o, i) => (o.id = response[i]));
        // re-populate the individual arrays with the new data
        this.populatePropertyArrays();

        this.developmentInputClient.addUpdateReturnOnlyID(this.developmentInput).then((devInputResponse) => {
          this.developmentInput.id = devInputResponse;
          this.CalcAll();
          this.setAllFormsPristine();
          this.saved = true;
          defer.resolve(response as number[]);
          //TODO: add to architecture delete all
          if (this.objectsMarkedForDeletion) {
            for (var i = 0; i < this.objectsMarkedForDeletion.length; i++) {
              if (this.objectsMarkedForDeletion[i].id) {
                this.developmentInputScheduleClient.markAsDeleted(this.objectsMarkedForDeletion[i].id);
              }
            }
            this.objectsMarkedForDeletion = [];
          }

          return response;
        });
      })
      .catch((response) => {
        defer.reject(response);
        this.error = true;
      })
      .finally(() => {
        this.saving = false;
      });
    return defer.promise;
  }

  delete() {
    this.developmentInputScheduleClient.markAsDeleted(this.selectedObject.id).then((response) => {
      if (response) {
        this.objects.splice(this.objects.indexOf(this.selectedObject), 1);
        this.DevelopmentInputscheduleForm.$setPristine();
        delete this.selectedObject;
      }
    });
  }

  cancel(): void {
    this.$location.path("/casedashboard/" + this.currentCaseNumber);
  }

  saveChanges(): void {
    this.dataLoading = true;
    this.save()
      .then((response) => {
        (this.$rootScope as any).formSaved = true;
        this.DevelopmentScheduleFormUnitsDetailForm.$setPristine();
        this.developmentScheduleForm.$setPristine();
        this.messageContent = "Your changes have been saved.";
      })
      .catch((error) => {
        this.messageContent = "Sorry, something went wrong while saving. Please try again.";
      })
      .finally(() => {
        this.dataLoading = false;
        this.showInformationMessage = true;
      });
  }

  goToCaseDashboard(saveChanges: boolean): void {
    if (saveChanges && this.roleService.IsLender != true) {
      this.save().then((response) => {
        (this.$rootScope as any).formSaved = true;
      });
    }
    this.$location.path("/casedashboard/" + this.currentCaseNumber);
  }

  closeModal(): void {
    this.showInformationMessage = false;
    this.$location.path("/casedashboard/" + this.currentCaseNumber);
  }

  updateGIA() {
    this.developmentInput.dI_AreaSalesAreaResidential = this.OverallSQft;
    this.developmentInputClient.addUpdateReturnOnlyID(this.developmentInput).then((devInputResponse) => {
      this.developmentInput.id = devInputResponse;
      this.developmentInput.dI_AreaSalesAreaResidential = this.OverallSQft;
      this.CalcAll();
      this.setAllFormsPristine();
      this.saved = true;
      return devInputResponse;
    });
    this.CalcOverallSQft();
  }

  updateGDV() {
    this.developmentInput.cI_GDV = this.OverallGDVLocal;
    this.developmentInputClient.addUpdateReturnOnlyID(this.developmentInput).then((devInputResponse) => {
      this.developmentInput.id = devInputResponse;
      this.developmentInput.cI_GDV = this.OverallGDVLocal;
      this.CalcAll();
      this.setAllFormsPristine();
      this.saved = true;
      return devInputResponse;
    });
  }

  //File upload

  calculateTotalFiles(filter: number) {
    if (this.fileUpload) {
      return this.fileUpload.length;
    }
  }

  calculateFilesForThisModule() {
    this.fileUpload = this.fileUpload.filter((file) => file.module === this.thisModuleSection);
    if (this.fileUpload.length <= 0) {
      this.seeInfo = true;
    } else {
      this.seeInfo = false;
    }
  }

  onFileSelect(files: FileAttachment[], module?: ModuleEnum) {
    if (files.length > 0) {
      this.fileAttachmentHelper
        .UploadFileLstInSync(files, this.uploadingFiles, this.case.id, this.fileUpload, module)
        .then((result) => {
          this.calculateFilesForThisModule();
          this.openModal = false;
        });
    }
  }

  downloadFile(file: FileAttachment) {
    this.fileAttachmentClient
      .getAmazonFileAccessUri(file.fileLocation)
      .then((uri) => {
        this.$window.open(uri);
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  deleteFile(file: FileAttachment) {
    this.fileUpload.splice(this.fileUpload.indexOf(file), 1);
    this.fileAttachmentClient.markAsDeleted(file.id).then((result) => {
      this.calculateFilesForThisModule();
    });
  }

  uploadYourOwnClicked() {
    event.preventDefault(); // prevents default behaviour of href
    this.openModal = true;
  }

  setAreaVal(area) {
    if (area === undefined || area === null) {
      return 0;
    } else {
      return area;
    }
  }

  populatePropertyArrays() {
    // First clear them:
    this.houses = [];
    this.flats = [];
    this.communalAreas = [];
    this.commercialUnits = [];
    this.parkingSpaces = [];

    // Then populate them from the main objects array
    this.houses = this.FilterMainObjects(ScheduleTypeEnum.House);
    this.flats = this.FilterMainObjects(ScheduleTypeEnum.Flat);
    this.communalAreas = this.FilterMainObjects(ScheduleTypeEnum.Communal);
    this.commercialUnits = this.FilterMainObjects(ScheduleTypeEnum.Commercial);
    this.parkingSpaces = this.FilterMainObjects(ScheduleTypeEnum.Parking);
  }

  //addSubobject() {
  //    this.selectedSubobject = {
  //        AssociatedObjectId: this.selectedObject.id,
  //        AssociatedObjectName: this.selectedObject.Name
  //    } as SubobjectDTO;
  //}

  //removeSubobject(subobject: SubobjectDTO) {
  //    this.$subobjectservice.deleteSubobject(subobject.id).then((response) => {
  //        this.subobjects.splice(this.subobjects.indexOf(this.selectedSubobject), 1);
  //        delete this.selectedSubobject;
  //    });
  //}

  //cancelUpdateSubobject() {
  //    delete this.selectedSubobject;
  //}

  //updateSubobject(subobject: SubobjectDTO) {
  //    this.$subobjectservice.addUpdateSubobject(subobject).then((response) => {
  //        if (this.subobjects.indexOf(subobject) === -1) {
  //            this.subobjects.push(subobject);
  //        }
  //        delete this.selectedSubobject;
  //    }).catch((response) => {
  //        delete this.selectedSubobject;
  //    });

  //}

  autofillSchedule() {
    this.developmentInput.howManyHouses = 2;
    this.houses = [];
    var house1 = {
      developmentInputId: this.developmentInput.id,
      scheduleType: ScheduleTypeEnum.House,
      locationIdentifier: "1",
      description: "Detached house",
      numberOfBeds: 4,
      numberOfBaths: 3,
      tenure: TenureEnum.Freehold,
      area: 1500,
      salesPrice: 1000000,
    } as DevelopmentInputSchedule;

    this.houses.push(house1);

    var house2 = {
      developmentInputId: this.developmentInput.id,
      scheduleType: ScheduleTypeEnum.House,
      locationIdentifier: "2",
      description: "Semi-detached house",
      numberOfBeds: 4,
      numberOfBaths: 3,
      tenure: TenureEnum.Freehold,
      area: 1500,
      salesPrice: 1500000,
    } as DevelopmentInputSchedule;

    this.houses.push(house2);

    this.developmentInput.houses_GDV = 2500000;
  }

  setDefaultValuesForDevelopmentInputSchedule() {
    this.objects.forEach((obj) => {
      obj.developmentInput = obj.developmentInput ?? null;
      obj.orderId = obj.orderId ?? 0;
      obj.locationIdentifier = obj.locationIdentifier ?? "";
      obj.description = obj.description ?? "";
      obj.numberOfBeds = obj.numberOfBeds ?? 0;
      obj.numberOfBaths = obj.numberOfBaths ?? 0;
      obj.flatStorey = obj.flatStorey ?? 0;
      obj.postCode = obj.postCode ?? "";
      obj.city = obj.city ?? "";
      obj.type = obj.type ?? UnitTypeEnum.None;
      obj.numberOfUnits = obj.numberOfUnits ?? 0;
      obj.area = obj.area ?? 0;
      obj.salesPrice = obj.salesPrice ?? 0;
      obj.note = obj.note ?? "";
      obj.tenure = obj.tenure ?? TenureEnum.Freehold;
      obj.classUse = obj.classUse ?? ClassUseEnum.A1E;
      obj.preAgreement = obj.preAgreement ?? PreAgreementEnum.None;
      obj.companyName = obj.companyName ?? "";
      obj.companyNumber = obj.companyNumber ?? 0;
      obj.lengthOfLetYears = obj.lengthOfLetYears ?? 0;
      obj.hasBreakClause = obj.hasBreakClause ?? false;
      obj.breakClauseLengthInYears = obj.breakClauseLengthInYears ?? 0;
      obj.annualRent = obj.annualRent ?? 0;
      obj.annualRentActualOrEstimated = obj.annualRentActualOrEstimated ?? 0;
      obj.dateSold = obj.dateSold ?? null;
      obj.areaUnit = obj.areaUnit ?? AreaUnitEnum.SquareMeters;
      obj.scheduleType = obj.scheduleType ?? ScheduleTypeEnum.House;
      obj.hasBalcany = obj.hasBalcany ?? false;
      obj.monthlyRent = obj.monthlyRent ?? 0;
      obj.id = obj.id ?? 0;
      obj.developmentInputId = obj.developmentInputId ?? this.developmentInput.id;
      obj.isDeleted = obj.isDeleted ?? false;
      obj.createdDateTime = obj.createdDateTime ?? null;
      obj.lastUpdatedDateTime = obj.lastUpdatedDateTime ?? null;
      obj.lastModifiedUser = obj.lastModifiedUser ?? null;
      obj.lastModifiedUserId = obj.lastModifiedUserId ?? null;
      obj.createdUserId = obj.createdUserId ?? null;
      obj.createdUser = obj.createdUser ?? null;
      obj.ownersApplicationUsers = obj.ownersApplicationUsers ?? [];
      obj.ownersApplicationUserGroups = obj.ownersApplicationUserGroups ?? [];
    });
  }
}
